import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'

import { PlantListHeader, PlantListSearch, SearchCancel, SearchClear } from '../StyledComponents/Plants/PlantList'
import { FillerDiv } from '../StyledComponents/Fillers'

const WAIT_INTERVAL = 800
const ENTER_KEY = 13

class SearchHeader extends Component {
    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.triggerChange = this.triggerChange.bind(this)
    }

    componentWillMount() {
        this.timer = null
    }

    handleChange(e) {
        clearTimeout(this.timer)

        this.props.onSearchQueryChange(e.target.value)

        this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL)
    }

    handleKeyDown(e) {
        if (e.keyCode === ENTER_KEY) {
            this.triggerChange()
        }
    }

    triggerChange() {
        const { searchQuery, onSearchTrigger } = this.props
        onSearchTrigger(searchQuery)
    }

    render() {
        const {
            searchActive, onSearchClose, searchQuery, onSearchTrigger,
        } = this.props

        if (!searchActive) {
            return null
        }

        const clearIcon = isEmpty(searchQuery)
            ? null
            : <SearchClear onClick={() => onSearchTrigger('')} name="times" />

        return (
            <FillerDiv>
                <PlantListHeader>
                    <FillerDiv className="container">
                        <FillerDiv className="row">
                            <FillerDiv className="col-9">
                                <PlantListSearch
                                    className="col-12"
                                    type="search"
                                    placeholder="Suche..."
                                    value={searchQuery}
                                    onChange={this.handleChange}
                                    onKeyDown={this.handleKeyDown}
                                />
                                {clearIcon}
                            </FillerDiv>
                            <SearchCancel className="col-3" onClick={onSearchClose}>
                                Abbrechen
                            </SearchCancel>
                        </FillerDiv>
                    </FillerDiv>
                </PlantListHeader>
            </FillerDiv>
        )
    }
}

export default SearchHeader



// WEBPACK FOOTER //
// ./src/components/Plant/SearchHeader.js